import {Home} from "../../components";
import DashboardParent from "../../components/dashboard/DashboardParent";
import {useAuthentication} from "../auth/hooks/useAuthentication";
import { useLocation } from "react-router-dom";
import {Subscription} from "../subscription/queries/subscription";
import {useEffect} from "react";
import CircularProgress from '@mui/material/CircularProgress';
import {Box} from "@mui/material";

const FirstPage = ({setShowNav}) => {
    const {isAuthenticated, isLoading} = useAuthentication();
    const myParam = useLocation().search;
    const stripeSessionId = new URLSearchParams(myParam).get("session_id");

    useEffect(() => {
        stripeSessionId && Subscription.saveSubscription(stripeSessionId)
    }, []);

    return (
        isLoading ?
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '80vh',
                }}
            >
                <CircularProgress size={50}/>
            </Box>
            :
        isAuthenticated ?
            <DashboardParent setShowNav={setShowNav}></DashboardParent> :
            <Home setShowNav={setShowNav}/>
    )
}

export default FirstPage;
